// extracted by mini-css-extract-plugin
export default {"videoControlButton":"WnL7S2NKfqldpB7aircd"};